<template>
  <div class="bgff">
    <div><img src="@/assets/images/banner4.png" class="banner" /></div>
    <div class="contList w1000">
      <div class="breadcrumb "><span class="cl00" @click="$goRouter('/')">首页</span> <span>></span> <span>新闻资讯</span> </div>
      <div class="titleList tc">
        <ul>
          <li v-for="(item,index) in titleList"
              :class="{'active': active === index}"
              @click="active = index; getInfoList()"
              :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="mt20">
        <div v-if="newsList.length !== 0">
          <div class="fs18 items" @click="goRouter(item)" v-for="(item,index) in newsList" :key="index">{{ item.infoTitle }}</div>
        </div>
        <div v-else class="tc mt66 cl7b">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo } from '@/api/news'

export default {
  name: 'list',
  data() {
    return {
      active: 0,
      newsList: [],
      titleList: ["行业资讯", "政策法规", "各省要求", "申请指南", "线路快讯"],
    }
  },
  mounted() {
    this.getInfoList()
  },
  methods: {
    goRouter ( item) {
      this.$router.push({path: '/news/details', query: {id: item.id}})
    },
    async getInfoList () {
      //POLICY政策 LAW-法规，STANDARD-标准，
      const codeList = ["NEWS", "POLICY", "PROV_REQUIRE", "APPLY_GUIDE", "FLASH_NEWS"]
      const {data} = await getInfo({
        categoryCode: codeList[this.active],
        limit: 200
      })
      this.newsList = data
    },
  }
}
</script>


<style scoped lang="less">
.banner{
  width: 100%;
  height: 260px;
  object-fit: cover;
}
.contList{
  min-height: calc(100vh - 260px);
  padding-bottom: 20px;
  ul {
    display: flex;
    justify-content: space-between;

    li {
      text-align: center;
      width: 33.333%;
      padding: 10px 0;
      color: rgba(15, 177, 192, 1);
      cursor: pointer;
      font-size: 24px;
      &:hover{
        border-bottom: 3px solid rgba(15, 177, 192, 1);
      }
    }

    .active {
      border-bottom: 3px solid rgba(15, 177, 192, 1);
    }
  }
  .titleList{
    width: 600px;
    margin: 0 auto;
  }
  .items{
    border-top: 1px solid rgba(240, 242, 246, 1);
    padding: 13px 0;
    position: relative;
    cursor: pointer;
    &:after {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background: #0fb1c0;
      position: absolute;
      top: 21px;
      left: -16px;
    }
    &:hover {
      color: rgba(15, 62, 170, 1);
    }
  }
}

.w1000{
  width: 1000px;
  margin: 0 auto;
  margin-top: 20px;
}
</style>